import { Collapsible } from 'src/components/ui/collapsible';
import { Button } from 'src/components/ui/button';
import { useEffect, useState } from 'react';
import { CalendlyWidget } from 'src/components/CalendlyWidget/CalendlyWidget';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { clsx } from 'clsx';

export const ArrangeCallOnboarding = ({ open = false, onButtonClick = () => {} }) => {
  const [isOpen, setIsOpen] = useState(open);
  const { data: userInfo } = useGetUsersMeQuery();
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    if (userInfo) {
      const fullName = `${userInfo?.first_name || ''} ${userInfo?.last_name || ''}`.trim();

      setName(fullName);
      setEmail(userInfo?.email || '');
    }
  }, [userInfo]);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const onClick = () => {
    setIsOpen(true);
    onButtonClick();
  };

  return (
    <div
      className={clsx(
        'md:min-w-[36rem] max-w-full flex flex-col gap-2.5 border border-[#05050D1A] rounded-sm-5 shadow-[0_4px_70px_0_#E5FEF4] px-10 pt-10 pb-9 transition-[width] duration-500',
        isOpen ? 'md:w-[68rem] max-md:w-full' : 'w-[36rem]',
      )}
    >
      <div className={'w-full flex flex-col gap-1.5'}>
        <h2 className={'text-ebony text-xl font-bold leading-[130%] text-center capitalize'}>
          Arrange a call to discuss details
        </h2>
        <p className={'text-ebony_opacity_70 text-sm font-medium text-center'}>
          Have questions? Let’s hop on a quick call and talk it through.
        </p>
      </div>
      <Collapsible open={isOpen} contentClassName={''}>
        <div className={'h-[1050px] overflow-y-auto'}>
          <CalendlyWidget name={name} email={email} />
        </div>
      </Collapsible>
      {!isOpen && (
        <div className={'w-full flex items-center justify-center'}>
          <Button
            // variant="bright-green"
            size="xl"
            className={'w-full max-w-[500px] text-sm font-semibold'}
            onClick={onClick}
          >
            Book a Call
          </Button>
        </div>
      )}
      <div>
        <p className={'text-base-xs text-ebony_opacity_30 text-center font-medium'}>
          You won’t lose the created AI Agent by booking a call.
        </p>
      </div>
    </div>
  );
};
